/** The campaign-settings sections and their order. Shared by the settings
 * layout (sidebar) and the index route (which redirects to the first enabled
 * section), so both agree on what exists and in which priority. */
export interface SettingsFlags {
	interview: boolean
	whatsappAi: boolean
}

export interface SettingsSection {
	to:
		| '/company/$companyId/$campaignId/settings/interview'
		| '/company/$companyId/$campaignId/settings/whatsapp-ai'
	labelKey: string
}

export function resolveSettingsSections(flags: SettingsFlags): SettingsSection[] {
	const sections: SettingsSection[] = []

	if (flags.interview) {
		sections.push({
			to: '/company/$companyId/$campaignId/settings/interview',
			labelKey: 'campaign.settings.interviewScheduling.title',
		})
	}
	if (flags.whatsappAi) {
		sections.push({
			to: '/company/$companyId/$campaignId/settings/whatsapp-ai',
			labelKey: 'campaign.settings.whatsappAiAgent.title',
		})
	}

	return sections
}
